(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.directive('messageTableRow', ['$rootScope', 'ItemTableService', 'HelperService', 'MessageService', 'Message', '$uibModal', 'Alert', MessageTableRowFn]);

    function MessageTableRowFn($rootScope, ItemTableService, HelperService, MessageService, Message, $uibModal, Alert) {
        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/messages/templates/message-table-row.template.html'
        };
        return directive;

        function link(scope, element, attrs) {
            // if editing -> this is the original backup
            var original = null;
            scope.isRingfoonAdmin = $rootScope.isRingfoonAdmin;
            scope.isRingfoonOperatorAdmin = $rootScope.isRingfoonOperatorAdmin;


            scope.play = function () {
                MessageService.play(scope.message.id);
            };

            // cancel editing -> show original
            scope.cancel = function () {
                if (original === null) {
                    ItemTableService.remove(scope.message.vmIndex);
                }
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, scope.message.vmIndex);
                    // remove backup
                    original = null;
                } // else
            };

            // save editing values
            scope.save = function () {
                ItemTableService.save(scope.message);

                // save backend
                saveBackend();
            };

            // backend save
            function saveBackend() {
                // prepare for save
                var item = new Message();
                item.extend(scope.message);
                item.prepareForSave();

                //udpate (adding new messages is not allowed)
                MessageService.update(item.id, item).then(function (result) {
                    // replace current with edited one
                    scope.message.extend(result.data);
                    Alert.success('Message updated successfully');

                    scope.calculateDuration();
                });
            } // save
        }
    }
})();